"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthsMatrixData = void 0;
const types_1 = require("../types");
const generateBooleanMatrix_1 = require("./generateBooleanMatrix");
const getMonthsMatrixData = (value) => {
    const matrix = generateBooleanMatrix_1.generateBooleanMatrix(12);
    value === null || value === void 0 ? void 0 : value.forEach((v) => {
        const index = types_1.MONTH_INDEX[v];
        matrix[index] = true;
    });
    return matrix;
};
exports.getMonthsMatrixData = getMonthsMatrixData;
//# sourceMappingURL=getMonthsMatrixData.js.map